module.exports = __webpack_public_path__ + "acebec012964ee1a10b97d1931faba1e.jpg";